import { Checkbox as CheckboxMui, type CheckboxProps } from '@mui/material';
import { Icon, IconName } from '@packages/shared-ui';
import { useStyles } from './Checkbox.styles';

type Props = CheckboxProps & {
  isOnDark?: boolean;
};

export default function Checkbox({
  isOnDark = false,
  className,
  ...props
}: Props) {
  const { classes, cx } = useStyles({ isOnDark });

  return (
    <CheckboxMui
      disableRipple
      icon={<Icon name={IconName.CHECKBOX_UNCHECKED} />}
      checkedIcon={<Icon name={IconName.CHECKBOX_CHECKED} />}
      {...props}
      className={cx(classes.root, className)}
    />
  );
}
